import {QuickAddItemType} from "../../../app/quick-add/@types";

// const debug = "GDSystemLink"
const debug = false

// function isInternalGoodDayLink(url: string): boolean {
//     try {
//         const parsedUrl = new URL(url, 'https://www.goodday.work'); // fallback base in case of relative URLs
//         const host = parsedUrl.hostname.toLowerCase();
//
//         return (
//             host === 'goodday.work' ||
//             host.endsWith('.goodday.work')
//         );
//     } catch (e) {
//         return false; // invalid URL
//     }
// }


export function openLink(url:string) {

    if (isGDSystemLink(url)) {
        return openGDSystemLink(url)
    }

    const isFullLink = url.substring(0,4) === 'http'

    gd.openInNewWindow('{0}{1}'.f(isFullLink ? '' : 'https://', url))
}

// function getPathFromUrl(url: string): string {
//     try {
//         const parsedUrl = new URL(url, 'https://goodday.work'); // base handles relative URLs
//         return parsedUrl.pathname;
//     } catch (e) {
//         return ''; // invalid URL
//     }
// }

// function convertToSystemLink(url:string):string {
//
//     if (!isInternalGoodDayLink(url)) {
//         // not GD link
//         return url
//     }
//
//
//     const path: string   = getPathFromUrl(url)
//
//     if (!path) return url
//
//
//     const pathArray = path.split('/')
//
//     switch (pathArray[0]) {
//
//         case 'crm':
//
//             break;
//
//         case 'request-form':
//         case 'chat':
//
//             return pathArray[0]
//
//
//         default:
//             return url
//     }
//
//
//
//     return url
// }


export function isGDSystemLink(url:string):boolean {

    // // it allows internal GD links i.e. gd://request-form/xxxx
    // const gdUrlRegex = /^gd:\/\/[a-zA-Z0-9\/]+$/;
    // gdUrlRegex.test(value)


    return url?.substring(0,5) === 'gd://'
}


export function openGDSystemLink(url:string):void {

    const path = url.substring(5)

    const pathArray = path.split('/')

    debug && console.log(debug, 'openGDSystemLink', pathArray, path, url)

    switch (pathArray[0]) {

        case 'crm':
            if (pathArray[1]==='accounts') {
                return gd.navigation.goTo('crm/companies?internalLink=true')
            }
            if (pathArray[1]==='contacts') {
                return gd.navigation.goTo('crm/contacts?internalLink=true')
            }

            gd.growl.error("Incorrect URL")

            return

        case 'request-form':

            const requestFormId = pathArray[1]
            if (requestFormId) {
                gd.openNew(QuickAddItemType.REQUEST, {id: requestFormId})
            }

            break

        case 'chat':

            const chatId = pathArray[1]
            if (chatId) {
                // gd.navigation.goToChat(chatId)
                gd.navigation.goToChatInternal(chatId)
            }

            break


        default:
            gd.navigation.goTo(path)
            // gd.growl.error("Incorrect URL")
            break
    }


}
